/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteApiPublicAppointmentDeleteReservation$Params {

/**
 * The appointment uuid for a reservation
 */
  uuid: string;
  '_locale': 'de' | 'en' | 'fr';
}

export function deleteApiPublicAppointmentDeleteReservation(http: HttpClient, rootUrl: string, params: DeleteApiPublicAppointmentDeleteReservation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteApiPublicAppointmentDeleteReservation.PATH, 'delete');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteApiPublicAppointmentDeleteReservation.PATH = '/api/public/{_locale}/appointment/{uuid}/reservation';
